const Steps = {
  USER_REGISTER: "USER_REGISTER",
  VERIFY_EMAIL: "VERIFY_EMAIL",
  SET_PASSWORD: "SET_PASSWORD",
  ACCOUNT_LINKING: "ACCOUNT_LINKING",
  SETUP_PASSWORD: "SETUP_PASSWORD"
};

export default Steps; 